import React, { Component } from "react"

export default class Portfolio extends Component {
   render() {
      return (
         <div className="container">
            <h1 className="mt-5 text-center fw-lighter">
               Hello From Portfolio
            </h1>
         </div>
      )
   }
}
